import { ImageWithFallback } from "./figma/image-with-fallback";
import { motion } from "framer-motion";

export function CTASection() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <section className="h-screen snap-start flex flex-col bg-white px-5 py-12 pb-32">
      <motion.div
        className="flex-1 flex flex-col items-center justify-center max-w-2xl mx-auto w-full"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false }}
      >
        <motion.h1
          variants={itemVariants}
          className="text-center mb-8"
          style={{ fontSize: "2.25rem", fontWeight: 800, lineHeight: 1.3 }}
        >
          궁금한 점은
          <br />
          먼저 무료로
          <br />
          상담해보세요
        </motion.h1>

        <motion.p
          variants={itemVariants}
          className="text-gray-600 text-center mb-12"
          style={{ fontSize: "1rem", fontWeight: 600 }}
        >
          입점하지 않아도 괜찮아요
        </motion.p>

        <motion.div
          variants={itemVariants}
          className="w-full bg-gradient-to-br from-blue-500 to-blue-600 rounded-3xl overflow-hidden shadow-xl"
        >
          <div className="relative w-full h-48">
            <ImageWithFallback
              src="https://images.unsplash.com/photo-1740818576358-7596eb883cf3?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjdXN0b21lciUyMHN1cHBvcnQlMjBjb25zdWx0YXRpb258ZW58MXx8fHwxNzY1OTY4NzkyfDA&ixlib=rb-4.1.0&q=80&w=1080"
              alt="무료 상담"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-900/60 to-transparent" />
          </div>
          <div className="p-8 text-center space-y-3">
            <p
              className="text-white"
              style={{ fontSize: "1.125rem", fontWeight: 700, lineHeight: 1.6 }}
            >
              우리 매장에 맞는
              <br />
              활용 방법만 안내드려요
            </p>
            <p
              className="text-white/90"
              style={{ fontSize: "1rem", fontWeight: 600 }}
            >
              부담 없이 문의 주세요 🙂
            </p>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
}
